import axios from "axios";
import {
  LABA_RUGI_GENERATE_FAIL,
  LABA_RUGI_GENERATE_REQUEST,
  LABA_RUGI_GENERATE_RESET,
  LABA_RUGI_GENERATE_SUCCESS,
  LABA_RUGI_GET_FAIL,
  LABA_RUGI_GET_REQUEST,
  LABA_RUGI_GET_RESET,
  LABA_RUGI_GET_SUCCESS,
} from "../constants/labaRugiConstants";
import {
  API_LABA_RUGI_GENERATE,
  API_LABA_RUGI_GET,
  API_LABA_RUGI_GET_DOWNLOAD,
  API_LABA_RUGI_GET_DOWNLOAD_PDF,
} from "../init/api_url";
import { Logout } from "../../loginModul/actions/loginAction";
import { ActGeneralButtonDownloadSuccess } from "../../../general/components/button/ButtonDownloadsrc/action";

export const DownloadGetLabaRugi =
  ({ tahun, bulan, outlet, namaOutlet = "" }) =>
  async (dispatch, getState) => {
    let fileName = "Laporan Laba Rugi " + namaOutlet + ".xlsx";
    const {
      userLogin: { token },
    } = getState();
    const data = await axios({
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: API_LABA_RUGI_GET_DOWNLOAD,
      method: "GET",
      responseType: "blob", // important
      params: {
        tahun: tahun,
        bulan: bulan,
        outlet: outlet,
      },
    });
    console.log("Download Data", data["Content-Disposition"], data);
    const url = window.URL.createObjectURL(new Blob([data.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    dispatch(ActGeneralButtonDownloadSuccess());
  };

export const DownloadPdfGetLabaRugi =
  ({ tahun, bulan, outlet, namaOutlet = "" }) =>
  async (dispatch, getState) => {
    let fileName = "Laporan Laba Rugi " + namaOutlet + ".pdf";
    const {
      userLogin: { token },
    } = getState();
    const data = await axios({
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: API_LABA_RUGI_GET_DOWNLOAD_PDF,
      method: "GET",
      responseType: "blob", // important
      params: {
        tahun: tahun,
        bulan: bulan,
        outlet: outlet,
      },
    });
    console.log("Download Data", data["Content-Disposition"], data);
    const url = window.URL.createObjectURL(new Blob([data.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    dispatch(ActGeneralButtonDownloadSuccess());
  };

export const GetLabaRugi =
  ({ tahun, bulan, outlet }) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: LABA_RUGI_GET_REQUEST,
      });
      const {
        userLogin: { token },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          tahun: tahun,
          bulan: bulan,
          outlet: outlet,
        },
      };
      const { data: data } = await axios.get(API_LABA_RUGI_GET, config);
      console.log("testing Action get laba rugi", data);
      dispatch({
        type: LABA_RUGI_GET_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response.status == 401) {
        dispatch(Logout());
      }
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      dispatch({
        type: LABA_RUGI_GET_FAIL,
        payload: message,
      });
    }
  };

export const RGetLabaRugi = () => async (dispatch, getState) => {
  dispatch({
    type: LABA_RUGI_GET_RESET,
  });
};

export const GenerateLabaRugi =
  ({ tahun, bulan, outlet }) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: LABA_RUGI_GENERATE_REQUEST,
      });
      const {
        userLogin: { token },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const { data: data } = await axios.post(
        API_LABA_RUGI_GENERATE,
        {
          tahun: tahun,
          bulan: bulan,
          outlet: outlet,
        },
        config
      );
      dispatch({
        type: LABA_RUGI_GENERATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response.status == 401) {
        dispatch(Logout());
      }

      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      dispatch({
        type: LABA_RUGI_GENERATE_FAIL,
        payload: message,
      });
    }
  };

export const RGenerateLabaRugi = () => async (dispatch, getState) => {
  dispatch({
    type: LABA_RUGI_GENERATE_RESET,
  });
};
